














import { defineComponent, computed } from '@vue/composition-api';

const CommonSubdistrictSelector = defineComponent({
  setup(props: any) {
    const itemsId = computed(() => {
      if (!props.list) return [];
      const temp: string[] = [];
      props.list.forEach((item: any) => {
        temp.push(item.id);
      });
      return temp;
    });
    const itemsName = computed(() => {
      if (!props.list) return [];
      const temp: string[] = [];
      props.list.forEach((item: any) => {
        temp.push(item.nameInThai);
      });
      return temp;
    });

    const _value = computed(() => props.value);

    return {
      itemsId,
      itemsDisplay: itemsName,
      _value,
    };
  },
  props: {
    level: {},
    label: {
      type: String,
      default() { return 'ตำบล/แขวง'; },
    },
    value: {
      type: [String, Number],
      default() { return ''; },
    },

    list: {
      type: Array,
      default() { return ['โปรดเลือกตำบล/แขวง']; },
    },
    showLabel: { default: false },
    rules: { default: '' },
  },
});

export default CommonSubdistrictSelector;
